module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-6 col-md-12 col-xs-12 px-6"
  }, [(_vm.busy) ? _c('div', {
    staticClass: "dummy-rank-container cl-card"
  }, [_vm._m(0)]) : _c('div', {
    staticClass: "rank-container cl-card"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('div', {
    staticClass: "rank"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("TOP\n            "), (_vm.isSchoolTotal) ? [_c('strong', [_vm._v(_vm._s(_vm.rateScore(_vm.schoolRate) || 0) + "%")])] : _c('strong', [_vm._v("-%")])], 2), _vm._v(" "), _c('div', {
    staticClass: "subtitle"
  }, [(_vm.isSchoolTotal) ? [_vm._v(_vm._s(_vm.schoolName) + " " + _vm._s(_vm.$t('common.standard')))] : [_vm._v(_vm._s(_vm.$t('common.standard_before_update')))]], 2), _vm._v(" "), _c('div', {
    staticClass: "school-icon-container"
  }, [_c('div', {
    staticClass: "background-icon"
  }, [_c('img', {
    attrs: {
      "src": '/static/images/ic-level-school-bg.svg',
      "alt": "school"
    }
  }), _vm._v(" "), (_vm.isSchoolTotal) ? _c('div', {
    staticClass: "icon",
    style: ({
      'margin-top': _vm.changedIcon(_vm.schoolRate).margin,
      'height': _vm.changedIcon(_vm.schoolRate).height
    })
  }, [_c('img', {
    attrs: {
      "src": '/static/images/ic_level_school_bg.svg',
      "alt": "school"
    }
  })]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  }, [_c('div', {
    staticClass: "rank"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("TOP \n            "), (_vm.isGradeTotal) ? [_c('strong', [_vm._v(_vm._s(_vm.rateScore(_vm.gradeRate) || 0) + "%")])] : _c('strong', [_vm._v("-%")])], 2), _vm._v(" "), _c('div', {
    staticClass: "subtitle"
  }, [(_vm.isGradeTotal) ? [_vm._v(_vm._s(_vm.$t('proficiency.standard')))] : [_vm._v(_vm._s(_vm.$t('common.standard_before_update')))]], 2), _vm._v(" "), _c('div', {
    staticClass: "grade-icon-container"
  }, [_c('div', {
    staticClass: "background-icon"
  }, [_c('img', {
    attrs: {
      "src": '/static/images/ic-level-total-bg.svg',
      "alt": "grade"
    }
  }), _vm._v(" "), (_vm.isGradeTotal) ? _c('div', {
    staticClass: "icon",
    style: ({
      'margin-top': _vm.changedIcon(_vm.gradeRate).margin,
      'height': _vm.changedIcon(_vm.gradeRate).height
    })
  }, [_c('img', {
    attrs: {
      "src": '/static/images/ic-level-total-100.svg',
      "alt": "grade"
    }
  })]) : _vm._e()])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row dummy-body"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('div', {
    staticClass: "dummy-title"
  }), _vm._v(" "), _c('div', {
    staticClass: "dummy-current-score"
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  }, [_c('div', {
    staticClass: "dummy-title"
  }), _vm._v(" "), _c('div', {
    staticClass: "dummy-current-score"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0b472b23","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/cat-main/components/CatRank.vue
// module id = 1553
// module chunks = 1